import gsap from "gsap";
//import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
//gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
gsap.registerPlugin(ScrollTrigger);

// PAGE COLOR POWER-UP
window.addEventListener("DOMContentLoaded", (event) => {

  // horizontal slider on desktop
  const scrollerSlides = document.querySelector(".horizontalScroller_slides");
  const fade_blue = document.querySelectorAll('.fade-block-blue');

  if (scrollerSlides) {
    const slides = gsap.utils.toArray(".horizontal-slide");
    
    let mm = gsap.matchMedia();
  
    mm.add("(min-width: 992px)", () => {
      gsap.to(slides, {
        xPercent: -100 * (slides.length - 1),
        ease: "none",
        scrollTrigger: {
          trigger: ".horizontalScroller",
          pin: true,
          scrub: 1,
          markers: false,
          //snap: 1 / (slides.length - 1),
          end: () => "+=" + scrollerSlides.scrollWidth
        }
      });
    });
  }

  // wenn kein element auf seite, kein gsap trigger, sonst ist die ganze seite blau by default
  if (fade_blue.length) {
    gsap.to("body", {
      "background-color": "rgba(0, 12, 62)",
      scrollTrigger: {
        trigger: ".fade-block-blue",
        scroller: "body",
        start: "top 70%",
        end: "bottom 60%",
        markers: false,
        scrub: 0, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
      }
    });
  }

});